import React from 'react';
import GridRow from '../GridRow';
import { useOrganization } from '../../contexts/OrganizationContext';
import signlyLogo from '../../assets/logo-header.svg';
import './SignaturePreview.css';

function SignaturePreview({ gridData, containerWidth = 600, scale = 1 }) {
    const { subscriptionPlan } = useOrganization();
    const isFreePlan = !subscriptionPlan || subscriptionPlan === 'free';

    // Parser le grid_data si c'est une string JSON
    const grid = typeof gridData === 'string' ? JSON.parse(gridData) : gridData;

    if (!grid || grid.length === 0) {
        return (
            <div className="signature-preview-empty">
                <p>Aucune donnée à afficher</p>
            </div>
        );
    }

    return (
        <div className="signature-preview-container" style={{ transform: `scale(${scale})`, transformOrigin: 'top center' }}>
            <div className="signature-preview-canvas" style={{ width: `${containerWidth}px` }}>
                {grid.map((row, rowIndex) => (
                    <GridRow
                        key={rowIndex}
                        row={row}
                        rowIndex={rowIndex}
                        totalRows={grid.length}
                        selectedRow={null}
                        selectedCell={null}
                        selectedElement={null}
                        containerWidth={containerWidth}
                        onSelectRow={() => {}}
                        onSelectCell={() => {}}
                        onSelectElement={() => {}}
                        onSelectNestedCell={() => {}}
                        onMoveRow={() => {}}
                        onDeleteRow={() => {}}
                        onAddNestedGrid={() => {}}
                        onClearCell={() => {}}
                        onClearNestedCell={() => {}}
                        onDeleteElement={() => {}}
                        onDrop={() => {}}
                        onDragOver={() => {}}
                        onCellResize={() => {}}
                        onElementDragStart={() => {}}
                        onElementDrop={() => {}}
                        onAddColumn={() => {}}
                        onDeleteColumn={() => {}}
                        onMoveColumn={() => {}}
                        onDeleteNestedColumn={() => {}}
                        onMoveNestedColumn={() => {}}
                        onAddNestedColumn={() => {}}
                        previewMode={true}
                    />
                ))}
                {isFreePlan && (
                    <div className="signly-badge">
                        <a href="https://www.signly.fr" target="_blank" rel="noopener noreferrer">
                            Propulsé par <img src={signlyLogo} alt="Signly" className="signly-badge-logo" />
                        </a>
                    </div>
                )}
            </div>
        </div>
    );
}

export default SignaturePreview;
